import renderComponent from './renderComponent';

const FootContainer = (props) => {
    return renderComponent(props);
};

export default FootContainer;
